var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditNameButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.803,
    height: 35.802,
    viewBox: "0 0 35.803 35.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24898",
    "data-name": "\\u30D1\\u30B9 24898",
    d: "M6,27.259v5.594h5.594L28.1,16.346l-5.594-5.594ZM32.411,12.035a1.5,1.5,0,0,0,0-2.111L28.928,6.441a1.5,1.5,0,0,0-2.111,0l-2.73,2.73,5.594,5.594,2.73-2.73Z",
    transform: "translate(-1.525 -1.526)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24899",
    "data-name": "\\u30D1\\u30B9 24899",
    d: "M0,0H35.8V35.8H0Z",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNameButton);
export default __webpack_public_path__ + "static/media/editNameButton.efc971c26cd2a3f6e36806896fb1699e.svg";
export { ForwardRef as ReactComponent };